const SHIPPING_PREFIX = '@@shipping/';

export const SHIPPING_ACTION_TYPES = {
    CALCULATE_REQUEST: `${SHIPPING_PREFIX}CALCULATE_REQUEST`,
    CALCULATE_SUCCESS: `${SHIPPING_PREFIX}CALCULATE_SUCCESS`,
    CALCULATE_FAILURE: `${SHIPPING_PREFIX}CALCULATE_FAILURE`,

    SET_SELECTED_OPTION: `${SHIPPING_PREFIX}SET_SELECTED_OPTION`,

    SET_ADDRESS: `${SHIPPING_PREFIX}SET_ADDRESS`,
    CLEAR_ADDRESS: `${SHIPPING_PREFIX}CLEAR_ADDRESS`,

    FETCH_PICKPOINTS_REQUEST: `${SHIPPING_PREFIX}FETCH_PICKPOINTS_REQUEST`,
    FETCH_PICKPOINTS_SUCCESS: `${SHIPPING_PREFIX}FETCH_PICKPOINTS_SUCCESS`,
    FETCH_PICKPOINTS_FAILURE: `${SHIPPING_PREFIX}FETCH_PICKPOINTS_FAILURE`,
    SELECT_PICKUP_POINT: `${SHIPPING_PREFIX}SELECT_PICKUP_POINT`,

    RESET_SHIPPING: `${SHIPPING_PREFIX}RESET_SHIPPING`,
}

export const SHIPPING_CONFIG = {
    CACHE_TIME: 5 * 60 * 1000,
}

export const SHIPPING_TYPES = {
    DELIVERING: 'SHIPPING_TYPE_DELIVERING',
    LOCAL_PICKUP: 'SHIPPING_TYPE_LOCAL_PICKUP',
}

export const SHIPPING_METHODS = {
    CDEK: 'cdek',
    OWN: 'own',
    DELLIN: 'dellin',
}